import React from 'react'

const DeleteIcon = () => (
    <svg width="24" height="24" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.5 14C24.5 8.20312 19.7969 3.5 14 3.5C8.20312 3.5 3.5 8.20312 3.5 14C3.5 19.7969 8.20312 24.5 14 24.5C19.7969 24.5 24.5 19.7969 24.5 14Z" stroke="#007C10" strokeMiterlimit="10" />
        <path d="M17.5 17.5L10.5 10.5" stroke="#007C10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.5 17.5L17.5 10.5" stroke="#007C10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export default DeleteIcon